module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("First published in Great Britain in 1998")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This edition published 2015 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("John Donald, an imprint of Birlinn Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("West Newington House")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("10 Newington Road")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Edinburgh")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("EH9 1QS")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.birlinn.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.birlinn.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN: 978 1 788853 60 6")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © John Bannerman 1998, 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of John Bannerman to be identified as the author of this work has been asserted by his estate in accordance with the Copyright, Designs and Patents Act, 1988")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored, or transmitted in any form, or by any means, electronic, mechanical or photocopying, recording or otherwise, without the express written permission of the publisher")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("British Library Cataloguing-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("A catalogue record for this book is available on request from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Typeset by "), _c('a', {
    attrs: {
      "href": "http://3btype.com",
      "target": "_blank"
    }
  }, [_vm._v("3btype.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Printed and bound in Britain by Bell and Bain Ltd, Glasgow")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0